import { center, srcCorregimientos } from '../../constants/services/map'

/* global google */


export function initMap(ops) {
  setTimeout(() => {
    try {
      startMap(ops);
    } catch (error) { }
  }, 1000);
}
function startMap(ops) {
  var map = new google.maps.Map(document.getElementById(ops.id), {
    center: center,
    zoom: ops.zoom,
    disableDefaultUI: true,
    styles: styles
  });
  HttpServiceCom(srcCorregimientos, map);

  

  switch (ops.type) {
    case 'heat': createHeat(ops.data, map); break
    case 'marker': createMarker(ops.data, map); break
    default: break
  }

}

function createMarker(vector, map) {
  vector.map(m => {
    return new google.maps.Marker({
      position: m,
      map,
      icon: 'https://siscmura-recursos.s3-us-west-1.amazonaws.com/mapIcons/homicidios.png'
    })
  })
}

function HttpServiceCom(src, map) {
  var xhttpIcon = new XMLHttpRequest();
  xhttpIcon.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        var xmlString = this.response;
        var parser = new DOMParser();
        var comunas = parser.parseFromString(xmlString, "text/xml");
        var polyCapa1 = CreatePolygonLater(comunas);
        var polys = polyCapa1.map(poly => {
          return poly.filter(point => {
            if(isNaN(point.lng) || point.lng === 0 || isNaN(point.lat) || point.lat === 0){
              return false
            }
            return true
          })
        })
        var docComunas = CreatePolygonMap(polys, '#000', 'com');
        SetPolysInMap(docComunas, map)
      }
      else {
        console.log('esto', this);
      }
    }
  };
  xhttpIcon.open("GET", src, true);
  // xhttpIcon.setRequestHeader('Content-Type', 'bolb');
  xhttpIcon.send();
}

// function fitAllMap(polys, map) {
//   let bounds = new google.maps.LatLngBounds();
//   for (let i = 0; i < polys.length; i++) {
//     bounds = getBounds(polys[i], bounds)
//   }
//   map.fitBounds(bounds);
// }

// function getBounds(poly, bounds) {
//   var latLngs = poly.getPath()
//   for (var i = 0; i < latLngs.length; i++) {
//     bounds.extend(latLngs.getAt(i));
//   }
//   return bounds
// }

function CreatePolygonLater(doc) {
  var polygons = [];
  var places = doc.getElementsByTagName('Placemark');
  for (let i = 0; i < places.length; i++) {
    polygons[i] = [];
    polygons[i] = GetCordsFromPlacemark(places[i]);
  }
  return polygons;
}

function GetCordsFromPlacemark(place) {
  var coords = place.getElementsByTagName('coordinates');
  var coordsVec = coords[0].innerHTML.split(" ");
  var resp = [];
  for (let i = 0; i < coordsVec.length; i++) {
    let vec = coordsVec[i].split(',');
    if (!i)
      continue;
    resp.push({ lng: Number(vec[0]), lat: Number(vec[1]) });
  }
  return resp;
}


function createHeat(vector, map) {
  let data = vector.map((value) => {
    return new google.maps.LatLng(value)
  });
  // let intensity = (vector.length * 0.15);
  const heatMap = new google.maps.visualization.HeatmapLayer({
    data: data,
  });
  heatMap.setMap(map);
}

function SetPolysInMap(polygon, map) {
  for (let i = 0; i < polygon.length; i++) {
    polygon[i].setMap(map);
  }
}

function CreatePolygonMap(polys, color, tipo) {
  var polygons = [];
  for (let i = 0; i < polys.length; i++) {
    var poly = new google.maps.Polygon({
      paths: polys[i],
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: '#fff',
      fillOpacity: 0.35
    });
    polygons.push(poly);
  }
  return polygons;
}
// function captura() {
//     html2canvas(document.querySelector("#capture"), {
//         useCORS: true
//     }).then(canvas => {

//         var imgData = canvas.toDataURL("image/jpeg", 1.0);
//         var pdf = new jsPDF('p', 'px', [1000, 1415]);

//         pdf.addImage(imgData, 'JPEG', 0, 0, 1000, 1415);
//         pdf.save("informe.pdf");
//         console.log(canvas);
//         // 	        document.body.appendChild(canvas)

//     });
// }

var styles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "white-color"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];